function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.62 2.66a9 9 0 10.08-.08zM14.5 14.5a7.79 7.79 0 110-11 7.8 7.8 0 010 11z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.054 4.295l1.09-1.089 2.142 2.143-1.09 1.089zM3.92 11.45v2.13h2.13l6.82-6.85-2.14-2.14-6.81 6.86z"
});
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.98 18"
  }, props), _ref, _ref2);
}
export default SvgPencil;